import { render, staticRenderFns } from "./MyAccountDownloads.vue?vue&type=template&id=2bffdc2a"
import script from "./MyAccountDownloads.vue?vue&type=script&lang=js"
export * from "./MyAccountDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports